<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col cols="12">
          <b-row>
            <b-col>
              <p><b>{{ item['title'] }}</b></p>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="item.createdAt">
              <p>{{$t('views.excmnote.show.created')}} - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="blockquote blockquote-default p-1">{{item.description}}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  props: ['noteId'],
  computed: {
    id () {
      return this.noteId
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deleteError: 'excmnote/del/error',
      error: 'excmnote/show/error',
      isLoading: 'excmnote/show/isLoading',
      item: 'excmnote/show/retrieved'
    })
  },

  components: {
    Loader
  },
  data () {
    return {
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeCreate () {
    checkPagePermission('notes', 'EXCMNoteShow')
  },

  beforeDestroy () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_notes-' + this.id)
    this.reset()
  },

  created () {
    if (this.id) {
      this.retrieve(this.id)
      this.channelNotesRooms = this.$store.state.Pusher.subscribe('e_x_c_m_notes-' + this.id)
      this.channelNotesRooms.bind('e_x_c_m_notes-' + this.id, data => {
        this.retrieve(this.id)
      })
    }
  },

  methods: {
    ...mapActions({
      del: 'excmnote/del/del',
      reset: 'excmnote/show/reset',
      retrieve: 'excmnote/show/retrieve'
    }),

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_notes/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMNoteList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    getIdLink (link) {
      return getId(link)
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMNoteList' }))
      }
    }
  }
}
</script>
